// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"4ae2b308","55":"ea3b336b","147":"a7680a31","171":"f5d86e68","374":"4770aa90","429":"343aa701","453":"f88f4a81","528":"a7680a31","681":"5882171f","780":"3f949bfe"}[chunkId] + ".chunk.js";
};